// extracted by mini-css-extract-plugin
export var blockTitle = "style-module--block-title--85120";
export var col = "style-module--col--0b5b9";
export var row = "style-module--row--fd62f";
export var smi = "style-module--smi--528b9";
export var smiBlock = "style-module--smi-block--baa75";
export var smiBlockNote = "style-module--smi-block-note--67636";
export var smiBlockNoteMin = "style-module--smi-block-note-min--a9012";
export var smiCol = "style-module--smi-col--d8648";
export var smiText = "style-module--smi-text--8e94a";